import {VulSourceItemChangeType} from "./VulSourceItemChangeType";
import {VulSourceItemChangeKind} from "./VulSourceItemChangeKind";

class VulSourceItemChangeLog {
    constructor(
        public id?: string,
        public timestamp?: Date,
        public type?: VulSourceItemChangeType,
        public changeKind?: VulSourceItemChangeKind,
        public jsonDataRaw?: string,
        public jsonData?: any,
        public attributesRaw?: string,
        public attributes?: any,
        public jsonDataSize?: number,
        public attributesSize?: number) {}

    public static fromPOJO(data: any) {
        if (!data) {
            return null;
        }

        const entity = new VulSourceItemChangeLog();

        entity.id = data.id;
        entity.timestamp = data.timestamp;
        entity.type = data.type;
        entity.changeKind = data.changeKind;
        entity.jsonDataRaw = data.jsonData ?? undefined;
        entity.jsonData = data.jsonData ? JSON.parse(data.jsonData) : null;
        entity.attributesRaw = data.attributes ?? undefined;
        entity.attributes = data.attributes ? JSON.parse(data.attributes) : null;
        entity.jsonDataSize = data.jsonDataSize;
        entity.attributesSize = data.attributesSize;

        return entity;
    }
}

export default VulSourceItemChangeLog;
